import type { PropsWithChildren } from "react";

export type BankTransferDetailProps = {
  title: string;
  value: string;
};
export const BankTransferDetail = ({
  title,
  value,
  children,
  ...props
}: BankTransferDetailProps & PropsWithChildren) => (
  <div
    className="ps-flex ps-gap-4 ps-justify-between ps-text-heading-v2-xs ps-text-text-base-secondary ps-font-body ps-items-baseline"
    {...props}
  >
    <div className="ps-text-body-md">{title}</div>
    <div className="ps-flex ps-items-center ps-gap-2 ps-text-label-md ps-font-sans ps-text-v2-text-base-primary">
      {value}
      {children}
    </div>
  </div>
);
